// API configuration
const API_CONFIG = {
  // Use localhost during development, api.raziai.com in production
  baseURL: process.env.NODE_ENV === 'production' 
    ? 'https://api.razirasht.ir/api'
    : 'http://localhost:56744/api', //56744
   
  uploadURL: process.env.NODE_ENV === 'production' 
    ? 'https://api.razirasht.ir/'
    : 'http://localhost:56744/',
    
  // Helper method to get the full URL for an endpoint
  getUrl: function(endpoint: string): string {
    // Remove leading slash if present to avoid double slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    return `${this.baseURL}/${cleanEndpoint}`;
  }
};

export default API_CONFIG;
